import { ApiBlockItemModel, CabinAmenitiesComponentElementModel } from '@shared/integrations/umbraco-taf-delivery-api/models';

interface ICabinBookingObjectAccommodation {
    cabinAccommodations?: ApiBlockItemModel[];
    groupAccommodations?: ApiBlockItemModel[];
}

// @ts-ignore
const CabinBookingObjectAccommodation = ({ cabinAccommodations, groupAccommodations }: ICabinBookingObjectAccommodation) => {
    return (
        <div className='row'>
            {groupAccommodations
                ? groupAccommodations.map((p, key) => {
                      const acc = p.content as CabinAmenitiesComponentElementModel;
                      return (
                          <div
                              className='col-sm-6 d-flex flex-wrap align-items-top column-gap-2 py-2'
                              key={key}
                          >
                              <span className=" material-symbols-outlined">{acc.properties?.cabinAmenityIcon}</span>
                              <span className='flex-1'>{acc.properties?.cabinAmenityName}</span>
                          </div>
                      );
                })
                : null}
            {cabinAccommodations
                ? cabinAccommodations.map((p, key) => {
                      const acc = p.content as CabinAmenitiesComponentElementModel;
                      return (
                          <div
                              className='col-sm-6 d-flex flex-wrap align-items-top column-gap-2 py-2'
                              key={key}
                          >
                              <span className="material-symbols-outlined">{acc.properties?.cabinAmenityIcon}</span>
                              <span>{acc.properties?.cabinAmenityName}</span>
                          </div>
                      );
                  })
                : null}
        </div>
    );
};

export default CabinBookingObjectAccommodation;
